import React, { useState, useContext, useEffect } from "react";
import { Col, Row, Form, Button, Spinner, FormGroup } from "react-bootstrap";
import { useForm } from "react-hook-form";
import "./Home.css";
import { FaPlus } from "react-icons/fa";
import Result from "../Result/Result";
import { toast, Toaster } from "react-hot-toast";
import Endpoints from "../../constants/Endpoints";
import Variables from "../../constants/Variables";
import axios from "axios";
import { axiosOpen } from "../../api/axios";
import { useNavigate } from "react-router-dom";
import Loader from "../../component/Loader/Loader";
// import { AuthContext } from "../../contexts/AuthProvider";
// import Loader from "../Loader/Loader";
function Proposal() {
  const [proposalData, setProposalData] = useState(null);
  const [clientData, setClientData] = useState("");
  const [isLoading, setLoading] = useState(false);
  const [data, setData] = useState(false);
  const [techs, setTechs] = useState("");
  const [regeneratedata, setRegenerateData] = useState("");
  // const techStacks = Variables.techStacks;
  const [questions, setQuestions] = useState(null);
  const [showText, setShowText] = useState(false);
  const [user, setUser] = useState("");
  const { register, handleSubmit, reset } = useForm();
  const [theme, setTheme] = useState("");
  const [propId, setPropId] = useState("");
  // New code start

  const [fields, setFields] = useState([""]);
  const navigate = useNavigate();
  const handleAddField = () => {
    if (fields[fields.length - 1] != "") {
      setFields([...fields, ""]);
    }
  };
  const handleFieldChange = (index, event) => {
    const fieldData = [...fields];
    fieldData[index] = event.target.value;
    setFields(fieldData);
    // console.log("Data", fieldData);
  };
  // New code end

  const onSubmit = async (data) => {
    setRegenerateData(data);
    data.clientQues = fields;
    setShowText(true);
    const body = JSON.stringify({
      userId: localStorage.getItem("userID"),
    });
    const user = await axiosOpen.post("api/user/getSingleUser", body);
    // console.log('user is',user)
    setUser(user.data.user);

    if (data?.techStack != "Select The Tech Stack") {
      setLoading(true);
      const formData = {
        techStack: data?.techStack,
        jobTitle: data?.jobTitle,
        jobDescription: data?.jobDes,
        clientQuestions: data?.clientQues,
        userid: localStorage.getItem("userID"),
        companyId: localStorage.getItem("compId"),
      };

      // console.log("Form Data", formData);
      setClientData(data?.clientName);
      await axios
        .post(Endpoints.addInfo, formData)
        // await axios.get("https://jsonplaceholder.typicode.com/todos/1")
        .then((response) => {
          // let result = response.data.msg;
          let result = response;
          // console.log('response is',result)
          if (result[0] === "\n") {
            result = result.slice(1);
          }

          // console.log(result);
          setProposalData(response.data.msg);
          setQuestions(response.data.answers);
          // setQuestions(result.data.title)
          setPropId(response.data.propId);
          setShowText(false);
        })
        .catch(({ response }) => {
          toast.error(response.data.msg);
          setLoading(false);
          setShowText(false);
        });
    } else {
      toast.error("Fill all the required fileds ");
      setShowText(false);
      reset();
    }
  };

  useEffect(() => {
    async function fetchData() {
      const response = await axiosOpen.get("/api/company/getdata/" + localStorage.getItem("userID"));
      const techstacks = await axiosOpen.get("api/techstack/getAllTechstacks/" + localStorage.getItem("userID"));
      if (techstacks?.data?.length == 0) {
        // toast.error("Sorry first you need to add a portfolio then you can generate proposals");
        await alert("Sorry first you need to add a portfolio then you can generate proposals")
        navigate("/portfolio");
      }
      setTechs(techstacks?.data);
      response?.data != null ? setData(false) : setData(true);
    }
    fetchData();
    document.body.className = `${showText ? "disable-bg" : ""}`;
  }, [showText]);

  return (
    <>
      <Toaster position="top-center" reverseOrder={false} />
      <div className="row">
        <div className="col-3"></div>
        {techs == "" ? (
          <Loader />
        ) : (
          <div className="col-9">
              <div className={`rt-home mt-5 ${showText ? "bg-blur" : ""}`}>
                {proposalData === null ? (
                  <Row className="">
                    <Col md="9">
                      <Form className="mt-3 bg-form p-5 shadow mb-3 rounded info-form" onSubmit={handleSubmit(onSubmit)}>
                        <fieldset disabled={showText}>
                          <div className="article-title mb-3">
                            <h3 className="title">Please fill up the below information to proceed</h3>
                          </div>
                          <Row>
                            <Col>
                              <Form.Group className="mb-4">
                                <Form.Label>Client Name</Form.Label>
                                <Form.Control {...register("clientName", { required: false })} type="text" placeholder="Mr John" />
                              </Form.Group>
                            </Col>
                            <Col>
                              <Form.Group className="mb-4">
                                <Form.Label>Tech Stack*</Form.Label>
                                <Form.Select aria-label="Default select example" {...register("techStack", { required: true })}>
                                  <option>Select The Tech Stack</option>
                                  {techs.map((item, index) => (
                                    <option key={index} value={item.tech_stack}>
                                      {item.tech_stack}
                                    </option>
                                  ))}
                                </Form.Select>
                              </Form.Group>
                            </Col>
                          </Row>
                          <Row>
                            <Form.Group className="mb-4">
                              <Form.Label>Job Title*</Form.Label>
                              <Form.Control {...register("jobTitle", { required: true })} type="text" placeholder="Title of the job" />
                            </Form.Group>
                          </Row>

                          <Row>
                            <FormGroup className="mb-4">
                              <Form.Label>Job Description*</Form.Label>
                              <Form.Control as="textarea" placeholder="Description of the job that shared by client" rows={6} {...register("jobDes", { required: true })} />
                            </FormGroup>
                          </Row>

                          <Row>
                            <FormGroup>
                              <Form.Label>Client Questions</Form.Label>
                              <div>
                                {fields.map((field, index) => (
                                  <Form.Control
                                    as="textarea"
                                    className="mb-4"
                                    placeholder="Ask your question"
                                    rows={3}
                                    key={index}
                                    value={field}
                                    onChange={(e) => handleFieldChange(index, e)}
                                  // {...register("clientQues", { required: false })}
                                  />
                                ))}
                                <div className="btn-container">
                                  <div className="new-field-btn" onClick={handleAddField}>
                                    <FaPlus />
                                    Add Question
                                  </div>
                                </div>
                              </div>
                            </FormGroup>
                          </Row>

                          <Button disabled={data} className="mt-4" variant="primary" type="submit">
                            Generate Proposal
                          </Button>
                        </fieldset>
                      </Form>
                    </Col>
                  </Row>
                ) : (
                  <div className="result">
                    <Result
                        clientName={clientData}
                        proposalLetter={proposalData}
                        questions={questions}
                        user={user}
                        propId={propId}
                        data={regeneratedata}
                        regenrate={onSubmit}
                        newRequest={() => {
                          reset();
                          setFields([""])
                          setProposalData(null);
                        }}
                      />
                    </div>
                )}
              </div>

              <div className={`${showText ? "bg-text" : "d-none"}`}>
                <div className="loading">
                  <Spinner as="span" animation="border" variant="primary" role="status" aria-hidden="true" />
                  <p>Please wait a moment while we process your request.</p>
                </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}

export default Proposal;
